export default function Home({onGoHome}) {
  return (
    <div onClick={onGoHome} className="home-indicator">
      <span className="home-icon">🏠</span>
      <span className="home">Home</span>
    </div>
  )
}